/**
 * Has dependency on floorplan-bundle.js
 */
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";

import LayoutsService from 'external-services/layouts-service/layouts.service';

const NS = 'SectionsPlanCtrl';

export default function SectionsPlanCtrl(
  $log, $state, $filter, $scope, $q, $window, structureService, Plan, Command
) {
  "ngInject";

  var vm = this;
  // model
  vm.title = 'Restaurant Plan';
  vm.mode = 'restaurant';
  //-- define public methods
  vm.save = save;
  vm.cancel = cancel;
  vm.planConfig = {
    structures: {
      enable: $window.config.plan.structures
    },
  };
  vm.planAccessor = {
    //directive functions
  };
  vm.planReady = false;

  //--listeners
  $scope.$watch(function () {
    return $scope.vm.planReady;
  }, function (newValue) {
    if (newValue === true) {
      init();
    }
  });

  function init() {
    //Load sections and layouts and create section with layouts entries, (sections with 0 layouts associated are not processed)
    $q.all([SectionLookupService.getSections(), LayoutsService.getAllLayouts(), structureService.get()]).then(function (results) {
      var inputs = [];
      _.each(results[0], function (section) {
        var layouts = _.filter(results[1], function (layout) {
          return section._id === layout.sectionId;
        });
        if (!_.isEmpty(layouts)) {
          inputs.push({
            section: section,
            layouts: layouts
          });
        }
      });
      vm.restaurantStructures = results[2];
      vm.planAccessor.enablePlan(false);
      vm.planAccessor.setStructures(vm.restaurantStructures.items);
      vm.planAccessor.setSectionsLayouts(inputs).then(function () {
        vm.planAccessor.selectLayer(Plan.Layers.Restaurant);
        vm.planAccessor.enablePlan(true);
        vm.planAccessor.saveState(Command.createPlanLoad());
      });
    });
  }

  function cancel() {
    $state.go('settings.floorplan');
  }

  function save(data) {
    //Only section.position need to be saved, other data are dirty from plan autopositioning computation
    SectionLookupService.getSections().then(function (origSections) {
      var operations = [];
      //Copy position over loaded section
      _.each(data.sections, function (section) {
        _.find(origSections, function (o) {
          return section._id === o._id;
        }).position = section.position;
      });
      //Save back loaded section with new positions
      operations.push(SectionLookupService.saveSections(origSections));
      //Save structures
      vm.restaurantStructures.items = data.structures;
      operations.push(structureService.save(vm.restaurantStructures));
      //On operations completed
      $q.all(operations).then(function () {
        $state.go('settings.floorplan');
      });
    });
  }
}
